var path = '/var/www/mmscny-website/src/app/components/publications-documents-milepost-archive/publications-documents-milepost-archive.html';
var html = " <reports-page-template details=$ctrl.details display-dropdown=false button-text=\"view issue\" title=\"Milepost Archive\" display-title=true pagination-details=$ctrl.paginationDetails on-page-change=$ctrl.onChange($event) is-pagination-enabled={{$ctrl.isPaginationEnabled}}> </reports-page-template>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/publications-documents-milepost-archive/publications-documents-milepost-archive.html
// module id = 709
// module chunks = 0